import {
  asyncActionFinish,
  asyncActionError,
} from '../../../../App/common/reduxs/async/asyncActions';
import { ASYNC_ACTION_START } from '../../../../App/common/reduxs/async/asyncConstant';
import {
  SITE_ADDRESS,
  SITE_ADDRESS_PEMBELAJARAN,
} from '../../../../App/common/data/siteConfig';
import { checkRes, checkErr } from '../../../../App/common/helpers/checkRes';
import { authLogout } from '../../../../App/login/redux/authAction';
import { closeModal } from '../../../../App/modals/redux/modalActions';
import { dateToLocalTime } from '../../../../App/common/helpers/timeConvert';
import { emailRecoveryUpdate } from './reduxAction';
import { activateEmailAuthUpdate } from '../../../../App/login/redux/authAction';

export const updatePassword = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'updatePassword' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('oldPass', values.oldPass);
    formData.append('newPass', values.newPass);
    try {
      let fetchData = await fetch(SITE_ADDRESS + 'password/', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }
      const status = response.status;
      dispatch(asyncActionFinish());
      return status;
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const checkEmailValidation = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'checkEmailValidation' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const email = values.emailRecovery;
    const code = values.code;
    const setAsUsername = values.setAsUsername;
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('email', email);
    formData.append('code', code);
    formData.append('setAsUsername', setAsUsername);

    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'email/check-email-validation',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);

      if (resultCheck) {
        throw resultCheck;
      }
      const status = response.status;
      const message = response.message;
      const remarks = response.remarks && JSON.parse(response.remarks);
      if (status === 'success')
        dispatch(
          emailRecoveryUpdate({
            email,
            setAsUsername,
            startTime: dateToLocalTime(new Date()),
          })
        );
      dispatch(asyncActionFinish());
      return { status, message, remarks };
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const checkEmailOTPCode = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'checkEmailOTPCode' });
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const vusn = auth.vusn;
    const userId = auth.userId;
    const code = values.code;
    const formData = new FormData();
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('code', code);

    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'email/check-email-otp-code',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }
      const status = response.status;
      const portaluser = response.portaluser;
      dispatch(asyncActionFinish());
      return { status, portaluser };
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const activateEmailRecovery = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'activateEmailRecovery' });
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const vusn = auth.vusn;
    const userId = auth.userId;
    const username = auth.username;
    const role = auth?.role?.role;
    const email = values.emailRecovery;
    const setAsUsername = values.setAsUsername;
    const formData = new FormData();
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('username', username);
    formData.append('role', role);
    formData.append('email', email);
    formData.append('setAsUsername', setAsUsername);

    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'email/activate-email-recovery',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 201, history);
      if (resultCheck) {
        throw resultCheck;
      }
      const status = response.status;
      const message = response.message;
      if (status === 'success') {
        dispatch(
          emailRecoveryUpdate({
            email: null,
            setAsUsername: false,
            startTime: null,
          })
        );
        dispatch(
          activateEmailAuthUpdate({
            username: setAsUsername ? email : auth.username,
            emailRecovery: email,
          })
        );
      }
      dispatch(asyncActionFinish());
      return { status, message };
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const cancelEmailValidation = () => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'cancelEmailValidation' });
    dispatch(
      emailRecoveryUpdate({
        email: null,
        code: null,
        setAsUsername: false,
        startTime: null,
      })
    );
    dispatch(asyncActionFinish());
  };
};

export const deleteAccount = (auth, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteAccount' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    try {
      let fetchData = await fetch(SITE_ADDRESS + 'delete-account/', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 201, history);
      if (resultCheck) {
        throw resultCheck;
      }
      history.push('/');
      dispatch(authLogout());
      dispatch(closeModal());
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};
